<p-dialog
  appendTo="body"
  styleClass="w-sm !bg-bg-surface-default !rounded-3xl !border-0 p-10 {{ styleClass }}"
  [modal]="true"
  [visible]="visible"
  [dismissableMask]="true"
  (visibleChange)="visibleChange.emit($event)">
  <ng-template pTemplate="headless">
    <app-button
      class="absolute top-4 right-4"
      theme="transparent"
      [icon]="true"
      (click)="_hide()">
      <ic-close-outline class="text-icon-subtle block h-5 w-5" />
    </app-button>
    <div class="space-y-6 pt-4">
      <div class="flex grow flex-col gap-3">
        <p class="text-text-default text-center font-bold">{{ title }}</p>
        <p class="text-text-subtle text-center text-sm">{{ description }}</p>
      </div>
      <div class="flex items-center gap-2">
        <app-button
          class="flex-1"
          (click)="_hide()">
          {{ cancelText }}
        </app-button>
        <app-button
          class="flex-1"
          theme="tint-brand"
          [disabled]="pending"
          (click)="submit.emit()">
          @if (pending) {
            <p-progressSpinner
              class="h-4 w-4"
              styleClass="!h-4 !w-4 !mx-0 !ml-2" />
          } @else {
            {{ confirmText }}
          }
        </app-button>
      </div>
    </div>
  </ng-template>
</p-dialog>
